import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import {useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, useAuth} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_BTCH_SCHD_SEARCH_FORM,
    SG_BTCH_SCHD_LIST,
} from "@/tra/tancis/ptli/btch/schd/service/PtliBtchSchdMgmtService";

/*
 * Manage schedules list
 * !== 스케줄관리 목록 ==!
 */
export const PTLI1202001Q = (props: any) => {
    useResource({
        defaultSchema: [{ area: "bsopClsfCd" }, { area: "comnCd", comnCd: "COM0024" }],
    });

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0047", "auth_ptli0048"],
    }); 
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Manage schedules Form !== 스케줄관리 Form ==!
        btchInfoSrch: useForm({
            defaultSchema: SF_BTCH_SCHD_SEARCH_FORM,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        btchSchdSrchList: useGrid({
            defaultSchema: SG_BTCH_SCHD_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getBtchSchdList: useFetch({
            api: (page = grid.btchSchdSrchList.page) =>
                APIS.getBtchSchdList(form.btchInfoSrch.getValues(), page, grid.btchSchdSrchList.size),
            enabled: comnUtils.isEmpty(form.btchInfoSrch.errors),
            key: [grid.btchSchdSrchList.page, grid.btchSchdSrchList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.btchInfoSrch.getValues(),
                    page: grid.btchSchdSrchList.page,
                    size: grid.btchSchdSrchList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        getBtchSchdList: () => {
            grid.btchSchdSrchList.setPage(0);
            fetch.getBtchSchdList.fetch(0);
        },
        // Enter Keyword text !== 검색어 엔터 이벤트 ==!
        onEnterKwdTxt: () => {
            grid.btchSchdSrchList.setPage(0);
            fetch.getBtchSchdList.fetch(0);
        }
    };

    const render = {
        cell: {
            btchSchdNm: (props: any) => {
                const { rowValues, value } = props;
                return (
                    <Link to={`${URLS.ptli1202004q}/${rowValues.btchSchdId}`}>
                        {value}
                    </Link>
                );
            },
        },
    };

    const kwdSel = form.btchInfoSrch.watch('kwdSel');

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.btchInfoSrch.schema.bsopClsfCd} />
                            <Group.Label label={"L_KWD"} />
                            <Group.Col padding={1}>
                                <Layout direction="row" gap={1}>
                                    <FormControl 
                                    {...form.btchInfoSrch.schema.kwdSel}
                                    />
                                    <FormControl 
                                    {...form.btchInfoSrch.schema.kwdTxt} 
                                    readOnly={!kwdSel}
                                    onEnter={handler.onEnterKwdTxt}
                                    />
                                </Layout>
                            </Group.Col>
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button role="reset" onClick={() => form.btchInfoSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role="search" onClick={handler.getBtchSchdList} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.btchSchdSrchList.grid} data={fetch.getBtchSchdList.data?.schdList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="new"
                        onClick={() => {
                            navigate(URLS.ptli1202002s);
                        }}
                    />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
